import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	config: {
		funnelFeatureFlag: 'creatives_spreadsheet',
	},

	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('female_funnel.pages.landing.title_spreadsheet'),
			size: 'large',
			uppercase: true,
		}),

		LandingImage: ({ ctx }): LandingComponentsConfig['LandingImage'] => {
			let img = null

			try {
				img = require(`@/assets/landing/spreadsheet/${ctx.language}.png`)
			} catch {
				img = require('@/assets/landing/spreadsheet/en.png')
			}

			return { img }
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
